import { Component } from 'react';
import DOM from './noAccess';

class NoAccess extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
    }

    componentDidMount() {
    }

    render() {
        return this.view();
    }
}
export default NoAccess;
